import React from 'react';
import { SudokuGame } from './SudokuGame';
import { useParams } from 'react-router-dom';
import { getDateSeed, verifyDateParam } from '../../lib/dateSeed';
import { isDevelopment } from '../../lib/utils';

export const Sudoku: React.FC = () => {
  const { seed, previewDate, previewDifficulty } = useParams();

  // Handle preview date if in development mode
  let verifiedDate: Date | null = null;
  let difficulty: number | null = null;
  let seedNumber: number | undefined;
  let isPreviewMode = false;

  if (isDevelopment() && previewDate) {
    // Preview mode - parse the date from the URL
    const [year, month, day] = previewDate.split('-').map(part => parseInt(part, 10));
    const parsedDate = new Date(year, month - 1, day); // Month is 0-indexed in JS Date
    if (!isNaN(parsedDate.getTime())) {
      verifiedDate = parsedDate;
      difficulty = previewDifficulty ? parseInt(previewDifficulty, 10) : 3;
      seedNumber = getDateSeed(parsedDate, difficulty);
      isPreviewMode = true;
    }
  } else {
    // Normal mode - use the seed parameter
    [verifiedDate, difficulty] = seed ? verifyDateParam(seed) : [null, null];
    seedNumber = seed && verifiedDate ? parseInt(seed, 10) : undefined;
  }

  return (
    <div className="sudoku-wrapper">
      <SudokuGame
        initialSeed={seedNumber}
        puzzleDate={verifiedDate}
        difficulty={difficulty}
        isPreviewMode={isPreviewMode}
      />
    </div>
  );
};

export default Sudoku;
